// CustomerSelectionModal.js
import React, { useState, useEffect, useContext, useRef } from 'react';
import 'datatables.net-bs5';
import $ from 'jquery';
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import Draggable from 'react-draggable';
import QuotationService from "../../../Quotation/Controller/QuotationController";
import Cookies from "js-cookie";
import PartService from "../../../Parts/Controller/PartController";
import { useNavigate, useLocation } from 'react-router-dom';
function PartSelectionModal({ show, onClose, parts, onSelectPart, ClientCompanyID }) {
    const { theme, toggleTheme } = useContext(ThemeContext);
    const navigate = useNavigate();
    let accordTheme = "accordion-header-light";
    if (theme == "dark") {
        accordTheme = "accordion-header-dark";
    }
    const [loading, setLoading] = useState(true);
    const [searchQuery, setSearchQuery] = useState('');
    const [totalPages, setTotalPages] = useState(1); // Total number of pages
    const [currentPage, setCurrentPage] = useState(1);
    const [poCount, setPOCount] = useState(0);
    const [partList, setPartData] = useState([]);
    const CompanyID = localStorage.getItem("CompanyID");
    const UserID = localStorage.getItem("UserID");
    const setSortConfigInCookie = (config) => {
        Cookies.set(`PartSort_${CompanyID}_${UserID}`, JSON.stringify(config), { expires: 365 });
    };
    const getSortConfigFromCookie = () => {
        const sortCookie = Cookies.get(`PartSort_${CompanyID}_${UserID}`);
        return sortCookie ? JSON.parse(sortCookie) : { key: 'ID', direction: 'desc' };
    };
    const [sortConfig, setSortConfig] = useState(getSortConfigFromCookie());
    const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
    };
    const setPageSizeInCookie = (pageSize) => {
        document.cookie = `pageSize=${pageSize};path=/;max-age=31536000`; // 1 year
    };
    const [filteredParts, setFilteredParts] = useState([]);
    const getPageSizeFromCookie = () => {
        const match = document.cookie.match(new RegExp('(^| )pageSize=([^;]+)'));
        return match ? parseInt(match[2], 10) : 10; // Default to 10 if no cookie is found
    };
    const [pageSize, setPageSize] = useState(getPageSizeFromCookie());

    /*  const fetchParts = async (ClientCompanyID = 0) => {
          try {
              const redirectCallback = () => navigate('/');
              const data = await QuotationService.GetAllParts(redirectCallback, ClientCompanyID);
              setPartData(data);
          } catch (error) {
              console.error('Error fetching parts:', error);
          }
      };*/


    const fetchParts = async (page, size, ClientCompanyID) => {
        try {

            setLoading(true);
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };

            const Start = Math.round((parseInt(page) * parseInt(size)) - (size - 1)).toString();
            const PageSize = size.toString();


            const data = await QuotationService.GetAllParts(redirectCallback, Start.toString(), PageSize.toString(),
                searchQuery.toString(), sortConfig.key.toString(), sortConfig.direction.toString(), ClientCompanyID);
            setFilteredParts(data);
            setPartData(data);


            const leadCount = await PartService.GetPartCount(redirectCallback, searchQuery);
            setPOCount(leadCount[0].TotalRecords);
            setTotalPages(Math.ceil(leadCount[0].TotalRecords / size));
        } catch (error) {
            console.error('Error fetching Teams:', error);
        }
        finally {
            setLoading(false); // Stop loading after fetching
        }
    };
    useEffect(() => {

        fetchParts(currentPage, pageSize, ClientCompanyID);
    }, [currentPage, pageSize, ClientCompanyID]);

    useEffect(() => {
        fetchParts(currentPage, pageSize, ClientCompanyID);
    }, [sortConfig, ClientCompanyID]);

    const tableRef = useRef();
    const [selectedRows, setSelectedRows] = useState([]);
    const handleCheckboxChange = (part) => {

        setSelectedRows(prev => {
            const exists = prev.find(p => p.PK_Stock_ID === part.PK_Stock_ID);
            if (exists) {
                return prev.filter(p => p.PK_Stock_ID !== part.PK_Stock_ID);
            } else {
                return [...prev, part];
            }
        });
    };
    const handleConfirmSelection = () => {
        onSelectPart(selectedRows);
        onClose();
        setSelectedRows([]);
    };
    const initDataTable = () => {
        if ($.fn.DataTable.isDataTable(tableRef.current)) {
            console.log('Destroying existing DataTable instance...');
            $(tableRef.current).DataTable().destroy();
        }

        console.log('Initializing DataTable...');
        $(tableRef.current).DataTable({
            dom: '<"row"<"col-sm-6 d-flex align-items-center"Bf><"col-sm-6 d-flex justify-content-end"p>>rt',
            pagingType: 'full_numbers',
            language: {
                search: "_INPUT_",
                searchPlaceholder: "Search..."
            },
            /*  buttons: [
                  {
                      text: '<img src="assets/img/resources/customer-add.png" class="top-icon" alt="Add icon" /><br /><strong>Add</strong>',
                      action: function (e, dt, node, config) {
                          handleCreateClientClick();
                      },
                      className: 'btn-dataTable'
                  }
              ],*/
            lengthChange: false,
            initComplete: function () {
                console.log('DataTable initialization complete.');
                $('.btn-dataTable').css('background', 'none');
                $('.btn-dataTable').css('border', 'none');
                $('.btn-dataTable').removeClass('btn-secondary');
                $('.btn-dataTable').removeClass('btn');
                $('.btn-dataTable').removeClass('btn-dataTable');
                //  $('.dt-search input[type="search"]').css('margin-left', '10px');
                //  $('.dt-search input[type="search"]').css('height', '25px');
            }
        });

        $('#datatable-search-container').append($('.dataTables_filter').html());
        $('.dataTables_filter').remove();
    };



    const handleRowClick = (part) => {
        onSelectPart(part);
        onClose();
    };
    const truncateText = (text, maxLength = 15) => {
        return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
    };
    const handleStart = (e, ui) => {
        e.stopPropagation();
    }
    const handlePageChange = (page) => {
        setFilteredParts([]);
        setPartData([]);
        if (page > 0 && page <= totalPages) {
            setCurrentPage(page);

        }
    };
    const handlePageSizeChange = (event) => {
        const newPageSize = parseInt(event.target.value, 10);
        setPageSize(newPageSize);
        setPageSizeInCookie(newPageSize);
        setCurrentPage(1); // Reset to the first page
    };
    const handleSearchButtonClick = async () => {
        setCurrentPage(1); // Reset to first page
        setFilteredParts([]);
        setPartData([]);
        const query = searchQuery.toLowerCase(); // Use current searchQuery state
        let columnsToSearch = searchColumns.length > 0
            ? searchColumns.join(",")
            : "ALL";
        setSearchOptions(columnsToSearch);
        const leadData = await QuotationService.GetAllParts(redirectCallback, currentPage, pageSize.toString(),
            query.toString(), sortConfig.key.toString(), sortConfig.direction.toString(), ClientCompanyID, columnsToSearch.toString());
        setFilteredParts(leadData);
        setPartData(leadData);

        const leadCount = await PartService.GetPartCount(redirectCallback, searchQuery, columnsToSearch.toString());
        setPOCount(leadCount[0].TotalRecords);
        setTotalPages(Math.ceil(leadCount[0].TotalRecords / pageSize)); // Set total pages dynamically


    };
    const handleSort = async (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }

        const newConfig = { key, direction };
        setSortConfig(newConfig);
        setSortConfigInCookie(newConfig);
        setCurrentPage(1);

        setSortConfig({ key, direction });
        const porderData = await QuotationService.GetAllParts(redirectCallback, "1", pageSize.toString(),
            searchQuery.toString(), key.toString(), direction.toString(), ClientCompanyID);

        const porderCount = await PartService.GetPartCount(redirectCallback, searchQuery);

        setPOCount(porderCount[0].TotalRecords);
        setFilteredParts(porderData);
        setPartData(porderData);

        setTotalPages(Math.ceil(porderCount[0].TotalRecords / pageSize));
    };
    const getRowColor = (freeStock, rangeFrom, rangeTo) => {
        if (parseFloat(freeStock) < parseFloat(rangeFrom)) {

            return 'red';
        } else if (parseFloat(freeStock) > parseFloat(rangeTo)) {
            return 'blue';
        }
        return 'black'; // Default color or any other color you'd like
    };
    const defaultColumnsForSearch = [
        "vc_StockCode",
        "vc_StockName",
        "mon_StockPrice",
        "mon_SalesPrice",
        "FK_StockCategory_ID",
        "vc_Barcode",
        "dec_Quantity",
        "dec_FreeStock",
        "dec_UnitWeight",
        "dec_Allocated",
        "dec_OnOrder",
        "psync",
        "StockType"
    ];
    const [searchColumns, setSearchColumns] = useState(defaultColumnsForSearch);
    const [searchOptions, setSearchOptions] = useState(defaultColumnsForSearch);
    const columnSearchOptions = [
        { value: "vc_StockCode", label: "Product Code" },
        { value: "vc_StockName", label: "Description" },
        { value: "mon_StockPrice", label: "Cost Price" },
        { value: "mon_SalesPrice", label: "Sale Price" },
        { value: "FK_StockCategory_ID", label: "Discount Category" },

        { value: "vc_Barcode", label: "Barcode" },
        { value: "dec_Quantity", label: "In Stock" },
        { value: "dec_FreeStock", label: "Free Stock" },
        { value: "dec_UnitWeight", label: "Weight" },
        { value: "dec_Allocated", label: "Allocated" },
        { value: "dec_OnOrder", label: "On Order" },
        { value: "UpdatedDate", label: "Updated Date" },
        { value: "psync", label: "Sync" },
        { value: "StockType", label: "Type" }

    ];
    return (
        <div className={`modal fade ${show ? 'show' : ''}`} style={{ display: show ? 'block' : 'none' }} tabIndex="-1" aria-labelledby="partModalLabel" aria-hidden={!show}>
            <div className="modal-dialog modal-lg">
                <Draggable handle=".modal-content" onStart={handleStart}
                    cancel="input, textarea, select, button, ul,li,table,a,ReactQuill,p">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="partModalLabel">Select Part</h5>
                            <button type="button" className="btn-close" onClick={onClose} aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-xl-12">
                                    <div className="card mb-30">
                                        <div className="card-body">
                                            <div className="table-responsive">

                                                <div className="row mb-3">
                                                    <div className="col-sm-1">
                                                        <select id="pageSize" className="form-control" value={pageSize} onChange={handlePageSizeChange}>
                                                            <option value={10}>10</option>
                                                            <option value={25}>25</option>
                                                            <option value={50}>50</option>
                                                            <option value={100}>100</option>
                                                        </select>
                                                    </div>
                                                    <label style={{ paddingLeft: "0px" }} className="col-sm-2" htmlFor="pageSize">entries per page: </label>
                                                    <div className="col-sm-6"></div>
                                                    <div className="col-sm-1" style={{ "textAlign": "right" }}>Search</div>
                                                    <div className="col-sm-2 d-flex justify-content-end">
                                                        <input
                                                            type="text"
                                                            value={searchQuery}
                                                            onChange={(e) => setSearchQuery(e.target.value)} // Update searchQuery state
                                                            className="form-control me-2" // Add margin to separate input and button
                                                            onKeyDown={(e) => {
                                                                if (e.key === 'Enter') {
                                                                    handleSearchButtonClick();
                                                                }
                                                            }}
                                                        />
                                                        <button onClick={() => handleSearchButtonClick()} style={{ background: "none", border: "none" }}>
                                                            <img src="assets/img/resources/search.png" class="top-icon" alt="Add icon" />
                                                        </button>
                                                    </div>



                                                </div>
                                                <div style={{ maxHeight: "60vh", overflow: "auto" }}>
                                                    <table className="table m-0 table-hover" ref={tableRef} style={{ "width": "100%" }}>
                                                        <thead classname="table-light" style={{ position: "sticky", top: 0, zindex: 2 }}>
                                                            <tr>
                                                                <th style={{ width: "3%" }}></th>

                                                                <th onClick={() => handleSort('vc_StockCode')} className="no-wrap"> Product Code
                                                                    <i
                                                                        className={`ms-1 icofont ${sortConfig.key === 'vc_StockCode'
                                                                            ? sortConfig.direction === 'asc'
                                                                                ? 'icofont-caret-up'
                                                                                : 'icofont-caret-down'
                                                                            : 'icofont-sorting'
                                                                            }`}
                                                                    ></i>
                                                                </th>

                                                                <th onClick={() => handleSort('vc_StockName')} className="no-wrap">Description<i
                                                                    className={`ms-1 icofont ${sortConfig.key === 'vc_StockName'
                                                                        ? sortConfig.direction === 'asc'
                                                                            ? 'icofont-caret-up'
                                                                            : 'icofont-caret-down'
                                                                        : 'icofont-sorting'
                                                                        }`}
                                                                ></i></th>
                                                                <th onClick={() => handleSort('StockType')} className="no-wrap">Type<i
                                                                    className={`ms-1 icofont ${sortConfig.key === 'StockType'
                                                                        ? sortConfig.direction === 'asc'
                                                                            ? 'icofont-caret-up'
                                                                            : 'icofont-caret-down'
                                                                        : 'icofont-sorting'
                                                                        }`}
                                                                ></i></th>


                                                                <th onClick={() => handleSort('mon_StockPrice')} className="no-wrap">Cose Price<i
                                                                    className={`ms-1 icofont ${sortConfig.key === 'mon_StockPrice'
                                                                        ? sortConfig.direction === 'asc'
                                                                            ? 'icofont-caret-up'
                                                                            : 'icofont-caret-down'
                                                                        : 'icofont-sorting'
                                                                        }`}
                                                                ></i></th>


                                                                <th onClick={() => handleSort('mon_SalesPrice')} className="no-wrap">Sale Price<i
                                                                    className={`ms-1 icofont ${sortConfig.key === 'mon_SalesPrice'
                                                                        ? sortConfig.direction === 'asc'
                                                                            ? 'icofont-caret-up'
                                                                            : 'icofont-caret-down'
                                                                        : 'icofont-sorting'
                                                                        }`}
                                                                ></i></th>

                                                                <th onClick={() => handleSort('FK_StockCategory_ID')} className="no-wrap">Discount Category<i
                                                                    className={`ms-1 icofont ${sortConfig.key === 'FK_StockCategory_ID'
                                                                        ? sortConfig.direction === 'asc'
                                                                            ? 'icofont-caret-up'
                                                                            : 'icofont-caret-down'
                                                                        : 'icofont-sorting'
                                                                        }`}
                                                                ></i></th>

                                                                <th onClick={() => handleSort('dec_Quantity')} className="no-wrap">In Stock<i
                                                                    className={`ms-1 icofont ${sortConfig.key === 'dec_Quantity'
                                                                        ? sortConfig.direction === 'asc'
                                                                            ? 'icofont-caret-up'
                                                                            : 'icofont-caret-down'
                                                                        : 'icofont-sorting'
                                                                        }`}
                                                                ></i></th>

                                                                <th onClick={() => handleSort('dec_FreeStock')} className="no-wrap">Free Stock<i
                                                                    className={`ms-1 icofont ${sortConfig.key === 'dec_FreeStock'
                                                                        ? sortConfig.direction === 'asc'
                                                                            ? 'icofont-caret-up'
                                                                            : 'icofont-caret-down'
                                                                        : 'icofont-sorting'
                                                                        }`}
                                                                ></i></th>

                                                                <th onClick={() => handleSort('dec_Allocated')} className="no-wrap">Allocated<i
                                                                    className={`ms-1 icofont ${sortConfig.key === 'dec_Allocated'
                                                                        ? sortConfig.direction === 'asc'
                                                                            ? 'icofont-caret-up'
                                                                            : 'icofont-caret-down'
                                                                        : 'icofont-sorting'
                                                                        }`}
                                                                ></i></th>

                                                               



                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {filteredParts.map(part => (
                                                                <tr key={part.PK_Stock_ID}>
                                                                    <td>
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={selectedRows.some(p => p.PK_Stock_ID === part.PK_Stock_ID)}
                                                                            onChange={() => handleCheckboxChange(part)}
                                                                        />
                                                                    </td>
                                                                    <td className="no-wrap">{part.vc_StockCode}</td>
                                                                    <td className="no-wrap">{truncateText(part.vc_Description)}</td>
                                                                    <td className="no-wrap">{truncateText(part.StockStatus)}</td>
                                                                    <td className="no-wrap">{part.mon_StockPrice}</td>
                                                                    <td className="no-wrap">{part.mon_SalesPrice}</td>
                                                                    <td className="no-wrap">{part.FK_StockCategory_ID ? part.FK_StockCategory_ID : "None"}</td>
                                                                    <td className="no-wrap" style={{ color: getRowColor(part.dec_FreeStock, part.dec_MinimumQuantity, part.dec_MaximumQuantity) }}>
                                                                        {part.StockType.toString() === "0"
                                                                            ? "NA"
                                                                            : `${parseFloat(part.dec_Quantity ?? 0).toFixed(part.DecimalPlaces ?? 0)} ${part.Measurment}`}</td>
                                                                    <td className="no-wrap" style={{ color: getRowColor(part.dec_FreeStock, part.dec_MinimumQuantity, part.dec_MaximumQuantity) }}>{part.StockType.toString() === "0"
                                                                        ? "NA"
                                                                        : `${parseFloat(part.dec_FreeStock ?? 0).toFixed(part.DecimalPlaces ?? 0)} ${part.Measurment}`} </td>
                                                                    <td className="no-wrap" style={{ color: getRowColor(part.dec_FreeStock, part.dec_MinimumQuantity, part.dec_MaximumQuantity) }}>
                                                                        {part.StockType.toString() === "0"
                                                                            ? "NA"
                                                                            : `${parseFloat(part.dec_OnOrder ?? 0).toFixed(part.DecimalPlaces ?? 0)} ${part.Measurment}`}</td>


                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                        <tfoot style={{ position: "sticky", bottom: 0, zIndex: 2, backgroundColor: "white" }}>
                                                            <tr>
                                                                <td colSpan={"10"}>
                                                                    <div className="pagination-controls" style={{ marginTop: "10px", marginBottom: "10px" }}>
                                                                        Showing {1 + (currentPage * pageSize) - pageSize} to {currentPage * (Math.min(poCount, pageSize))} of {poCount} entries

                                                                        {/* Last Page Button */}
                                                                        <button
                                                                            style={{  float: "right", marginLeft: "5px" }}
                                                                            className='btn btn-info'
                                                                            onClick={() => handlePageChange(totalPages)} // Navigate to last page
                                                                            disabled={currentPage === totalPages}
                                                                        >
                                                                           
 <img src="assets/img/resources/last.png" alt="Add icon" style={{ height: "10px" }} /> Last
                                                                        </button>

                                                                        {/* Next Page Button */}
                                                                        <button
                                                                            style={{  float: "right", marginLeft: "5px" }}
                                                                            className='btn btn-info'
                                                                            onClick={() => handlePageChange(currentPage + 1)}
                                                                            disabled={currentPage === totalPages}
                                                                        >
                                                                          <img src="assets/img/resources/next-icon.png" alt="Add icon" style={{ height: "10px" }} />  Next
                                                                        </button>

                                                                        <span style={{ marginLeft: "10px", marginRight: "10px", float: "right" }}>
                                                                            Page {currentPage} of {totalPages}
                                                                        </span>

                                                                        {/* Previous Page Button */}
                                                                        <button
                                                                            style={{  float: "right", marginRight: "5px", marginLeft: "5px" }}
                                                                            className='btn btn-info'
                                                                            onClick={() => handlePageChange(currentPage - 1)}
                                                                            disabled={currentPage === 1}
                                                                        >
                                                                            <img src="assets/img/resources/pevious-icon.png" alt="Add icon" style={{ height: "10px" }} /> Prev
                                                                        </button>

                                                                        {/* First Page Button */}
                                                                        <button
                                                                            style={{  float: "right" }}
                                                                            className='btn btn-info'
                                                                            onClick={() => handlePageChange(1)} // Navigate to first page
                                                                            disabled={currentPage === 1}
                                                                        >
                                                                            <img src="assets/img/resources/first.png" alt="Add icon" style={{ height: "10px" }} /> First
                                                                        </button>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </tfoot>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="modal-footer">
                                            <button className="btn btn-primary" onClick={handleConfirmSelection}>
                                                Save
                                            </button>
                                            <button type="button" className="btn btn-secondary" onClick={onClose}>Close</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </Draggable>
            </div>
        </div>
    );
}

export default PartSelectionModal;
